const newBrowser =
  "fetch" in window &&
  "Promise" in window &&
  "assign" in Object &&
  "keys" in Object;

const tag = window.__WEBPACK_SETUP_DATA__.polyfillScriptTag;

if (!newBrowser) {
  document.write(tag);
}
